import { trpc } from '@/lib/trpc';
import { User } from '../User';

const useAppleAuth = () => {
	const utils = trpc.useUtils();

	const { mutate, isPending, error } = trpc.user.appleAuth.useMutation({
		onSuccess: (response) => {
			if (!response.user) return;
			utils.user.get.setData(undefined, () => {
				return {
					status: 200,
					user: {
						...(response.user as User),
					},
				};
			});
			utils.user.get.invalidate();
		},
	});

	return {
		appleAuth: mutate,
		appleAuthLoading: isPending,
		appleAuthError: error,
	};
};

export default useAppleAuth;
